import {
    getOfferDetailsCall,
    getOffersInfoMappedByLocale,
    OffersInfo,
} from '@sxm-de/dev-kits/web-sdk/domains/offers';
import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';

interface GetOrderFnPayload {
    orderId: string;
}

export type GetOrderFn = (payload: GetOrderFnPayload) => Promise<{
    order: unknown;
    hasPromotionalTerm: boolean;
    offersInfo: OffersInfo[];
}>;

export function initGetOrderFn({
    dependencies,
    countryCodeDefault,
    locale,
}: DomainInitPayload): GetOrderFn {
    const { clientSdk, microservicesSdk } = dependencies;
    return async ({ orderId }) => {
        try {
            const order = await clientSdk.commerce.order.getOrder(orderId);
            const offerId = order['offerId'] || '';
            const offer = await getOfferDetailsCall({ offerId }, dependencies);
            const offersInfo = await getOffersInfoMappedByLocale(
                {
                    offerIds: [offerId],
                    countryCode: countryCodeDefault,
                    locale,
                },
                dependencies,
            );

            const hasPromotionalTerm = !!offer?.offer?.phases?.find(
                (phase: any) =>
                    ['introductory', 'free'].some((type) =>
                        phase.type.toLowerCase().includes(type),
                    ) &&
                    'finite' in phase.duration &&
                    phase.duration.finite.length > 0,
            );

            return {
                order,
                hasPromotionalTerm,
                offersInfo,
            };
        } catch (error: any) {
            /**
             * TODO:
             * Log error to error logger (not analytics).
             */
            throw new Error('SYSTEM');
        }
    };
}
